module.exports = __webpack_public_path__ + "img/blue.db5499bf.png";